import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProfileSettingsComponent} from './profile-settings/profile-settings.component';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SeekerProfileReassignComponent} from './seeker-profile-reassign/seeker-profile-reassign.component';
import {SeekerProfileDiscipleshipComponent} from './seeker-profile-discipleship/seeker-profile-discipleship.component';
import {SeekerRequestMenuComponent} from './seeker-request-menu/seeker-request-menu.component';
import {SeekerRequestMoreComponent} from './seeker-request-more/seeker-request-more.component';
import {SeekerRequestTemplatesComponent} from './seeker-request-templates/seeker-request-templates.component';
import {SeekerRequestAddTemplateComponent} from './seeker-request-add-template/seeker-request-add-template.component';
import {SeekerRequestResourcesComponent} from './seeker-request-resources/seeker-request-resources.component';
import {SeekerRequestDocumentComponent} from './seeker-request-document/seeker-request-document.component';
import {SeekerUsefulLinksComponent} from './seeker-useful-links/seeker-useful-links.component';
import {SeekerDuplicateMergeComponent} from './seeker-duplicate-merge/seeker-duplicate-merge.component';
import {WelcomeVideoComponent} from './welcome-video/welcome-video.component';
import {BroadcastDisciplesMessagesComponent} from './broadcast-disciples-messages/broadcast-disciples-messages.component';
import {ComingSoonComponent} from './coming-soon/coming-soon.component';
import {NotificationComponent} from './notification/notification.component';
import {CustomFooterComponent} from './custom-footer/custom-footer.component'
import {TooltipModule} from '@amin-karimi/ng2-tooltip-directive';
import {ExpandableComponent} from './expandable/expandable.component';
import {SeekerRequestBibleVersionComponent} from './seeker-request-bible-version/seeker-request-bible-version.component'
import {OnVacationComponent} from './on-vacation/on-vacation.component'
import {EditVerseComponent} from './edit-verse/edit-verse.component'
import { PipesModule } from '../pipes/pipes.module';
import {NotificationBellComponent} from './notification-bell/notification-bell.component';
import {DatePicker} from "./date-picker/date-picker.component";
import {DropdownCheckboxComponent} from './dropdown-checkbox/dropdown-checkbox.component';
import {SeekerRequestCopilotDemoComponent} from "./seeker-request-copilot-demo/seeker-request-copilot-demo.component";

@NgModule({
    exports: [
        ProfileSettingsComponent,
        SeekerProfileReassignComponent,
        SeekerProfileDiscipleshipComponent,
        SeekerRequestMenuComponent,
        SeekerRequestMoreComponent,
        SeekerRequestTemplatesComponent,
        SeekerRequestAddTemplateComponent,
        SeekerRequestResourcesComponent,
        SeekerRequestDocumentComponent,
        SeekerRequestCopilotDemoComponent,
        SeekerUsefulLinksComponent,
        SeekerDuplicateMergeComponent,
        WelcomeVideoComponent,
        BroadcastDisciplesMessagesComponent,
        ComingSoonComponent,
        NotificationComponent,
        CustomFooterComponent,
        ExpandableComponent,
        SeekerRequestBibleVersionComponent,
        OnVacationComponent,
        EditVerseComponent,
        NotificationBellComponent,
        DatePicker,
        DropdownCheckboxComponent
    ],
    declarations: [
        ProfileSettingsComponent,
        SeekerProfileReassignComponent,
        SeekerProfileDiscipleshipComponent,
        SeekerRequestMenuComponent,
        SeekerRequestMoreComponent,
        SeekerRequestTemplatesComponent,
        SeekerRequestAddTemplateComponent,
        SeekerRequestResourcesComponent,
        SeekerRequestDocumentComponent,
        SeekerRequestCopilotDemoComponent,
        SeekerUsefulLinksComponent,
        SeekerDuplicateMergeComponent,
        WelcomeVideoComponent,
        BroadcastDisciplesMessagesComponent,
        ComingSoonComponent,
        NotificationComponent,
        CustomFooterComponent,
        ExpandableComponent,
        SeekerRequestBibleVersionComponent,
        OnVacationComponent,
        EditVerseComponent,
        NotificationBellComponent,
        DatePicker,
        DropdownCheckboxComponent
    ],
    imports: [
        FormsModule,
        IonicModule.forRoot(),
        CommonModule,
        TooltipModule,
        PipesModule
    ],
    providers: []
})
export class ComponentModule {
}
